import { render, staticRenderFns } from "./VideoCustomize.vue?vue&type=template&id=19e7c74e&scoped=true&"
import script from "./VideoCustomize.vue?vue&type=script&lang=js&"
export * from "./VideoCustomize.vue?vue&type=script&lang=js&"
import style0 from "./VideoCustomize.vue?vue&type=style&index=0&id=19e7c74e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e7c74e",
  null
  
)

export default component.exports